/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'tools-cursor-1': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M14.375 17.5a.625.625 0 01-.444-.181L10.1 13.48l-2.081 3.125a.625.625 0 01-.625.275.625.625 0 01-.506-.437l-3.75-12.5a.625.625 0 01.793-.819l12.5 3.75c.232.07.402.267.438.506a.625.625 0 01-.275.625l-3.125 2.082 3.837 3.83a.625.625 0 010 .888l-2.5 2.5a.625.625 0 01-.431.194zm0-1.506l1.619-1.619-4.475-4.469L14.8 7.72 4.681 4.68 7.72 14.8l2.187-3.281 4.469 4.475z"/>'
  }
})
